"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdditionalLuggageCount = exports.getTotalLuggageCount = void 0;
const getTotalLuggageCount = (passengers) => {
    // The luggage is assigned in pairs so we divide its count by 2.
    // Every passenger has by default 1 luggage pair: [LuggageType.Suitcase, LuggageType.CarryOn]
    return passengers.reduce((acc, p) => acc + Math.ceil(p.luggage.length / 2), 0);
};
exports.getTotalLuggageCount = getTotalLuggageCount;
const getAdditionalLuggageCount = (passengers) => {
    return Math.max(0, (0, exports.getTotalLuggageCount)(passengers) - passengers.length);
};
exports.getAdditionalLuggageCount = getAdditionalLuggageCount;
//# sourceMappingURL=getLuggageCount.js.map